import React, { useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import classNames from 'classnames';

import { Arrow, Location } from '@/icons/index';
import { Button, SectionTitle, TextBlock } from '@/ui/index';

import styles from './Vacancies.module.scss';

const VacanciesListItem = ({
  item,
  onApply = () => null,
  cities,
  setPositionId = () => null,
}) => {
  const { t } = useTranslation();
  const [isActive, setIsActive] = useState(false);

  const findCity = cities?.find((c) => c?.id === item?.city_id);

  const openVacancy = ({ target }) => {
    if (target.dataset.stop) return onApply(item);
    setPositionId(item?.id);
    setIsActive(!isActive);
  };

  return (
    <div
      className={classNames(styles['vacancy-item'], {
        [styles['vacancy-item--active']]: isActive,
      })}
    >
      <div className={styles['vacancy-item__head']} onClick={openVacancy}>
        <div className={styles['vacancy-item__content']}>
          {item?.department && (
            <span className={styles['vacancy-item__category']}>
              {item?.department?.name}
            </span>
          )}
          {item?.title && (
            <SectionTitle
              titleModify={classNames([
                styles['vacancy-item__title'],
                'title--small',
              ])}
            >
              {item.title}
            </SectionTitle>
          )}
          {findCity?.name && (
            <div className={styles['vacancy-item__city']}>
              <Location className={styles['vacancy-item__city-icon']} />
              <span className={styles['vacancy-item__city-text']}>
                {findCity?.name}
              </span>
            </div>
          )}
        </div>
        <div className={styles['vacancy-item__additional']}>
          <Button
            className={styles['vacancy-item__button']}
            data-stop
            onClick={() => setPositionId(item?.id)}
          >
            {t('common:Apply')}
          </Button>
          <Arrow className={styles['vacancy-item__arrow']} />
        </div>
      </div>
      <div className={styles['vacancy-info']}>
        {!!item?.description && (
          <div className={styles['vacancy-info__head']}>
            <TextBlock
              className={classNames([
                styles['vacancy-info__desc'],
                'text--medium',
              ])}
              isHtml
            >
              {item?.description}
            </TextBlock>
          </div>
        )}
      </div>
    </div>
  );
};

export default VacanciesListItem;
